import { Segmented, Typography } from "antd";
import { useState } from "react";
import ActivationAnalyticsView from "./ActivationAnalyticsView";
import AdUserOpenIdExportPanel from "./AdUserOpenIdExportPanel";
import AdPlayAnalyticsView from "./AdPlayAnalyticsView";
import TencentAdsRetentionView from "./TencentAdsRetentionView";
import { CommercialWrap, ModeBar } from "./commercialAnalyticsStyles";

type CommercialMode = "activation" | "adPlay" | "retention";

export default function CommercialAnalyticsPanel() {
  const [mode, setMode] = useState<CommercialMode>("activation");

  return (
    <CommercialWrap>
      <ModeBar>
        <div>
          <Typography.Title level={5} style={{ margin: 0 }}>商业化统计</Typography.Title>
          <Typography.Text type="secondary">
            统一查看玩家激活归因、广告播放质量与腾讯次日留存回传状态。
          </Typography.Text>
        </div>
        <Segmented
          value={mode}
          options={[
            { label: "激活统计", value: "activation" },
            { label: "广告统计", value: "adPlay" },
            { label: "次日留存回传", value: "retention" },
          ]}
          onChange={(value) => setMode(value as CommercialMode)}
        />
      </ModeBar>
      <AdUserOpenIdExportPanel />
      {mode === "activation"
        ? <ActivationAnalyticsView />
        : mode === "adPlay"
          ? <AdPlayAnalyticsView />
          : <TencentAdsRetentionView />}
    </CommercialWrap>
  );
}
